import axios from 'axios';
import config from 'config';
import { getAuth } from 'firebase/auth';

const apiBase = config.apiUrl;

export async function startResearch({ query, market = 'US', model = 'o4-mini-deep-research', show_thoughts = false }) {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Not authenticated');
  const token = await user.getIdToken();

  const url = `${apiBase}/agentic/research/start`;
  const body = { query, market, model, show_thoughts };

  const res = await axios.post(url, body, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    withCredentials: true
  });

  return res.data?.stream_url;
}

export function openResearchStream(streamUrl, { onOpen, onToken, onComplete, onError } = {}) {
  // Ensure absolute URL if backend returns relative path
  const absoluteUrl = streamUrl.startsWith('http')
    ? streamUrl
    : `${apiBase}${streamUrl.startsWith('/') ? '' : '/'}${streamUrl}`;

  const es = new EventSource(absoluteUrl, { withCredentials: true });

  es.addEventListener('open', (e) => {
    onOpen && onOpen(e);
  });

  es.addEventListener('token', (e) => {
    try {
      const data = JSON.parse(e.data);
      onToken && onToken(data);
    } catch (err) {
      // ignore malformed tokens
    }
  });

  es.addEventListener('complete', (e) => {
    onComplete && onComplete(e);
    es.close();
  });

  es.addEventListener('error', (e) => {
    onError && onError(e);
    es.close();
  });

  return es;
}


